import React, {useEffect, useState} from "react";
import {getAbandonedCheckoutsPreview} from "../../api/getAbandonedCheckoutsPreview";
import useUserContext from "../../hooks/useUserContext";
import {formatDate, formatDateForAmPmDisplay, formatDateNoTime} from "../../utils/friendlyDate";
import "./dashboard-preview.css";
import {Tooltip} from "antd";
import LongArrowRight from "../../assets/icons/LongArrowRight";
import {EyeOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import SkeletonItem from "../skeleton/SkeletonItem";
import Skeleton, {SkeletonRow, SkeletonTableRow} from "../skeleton/Skeleton";
import {getMessagesLogPreview} from "../../api/getMessagesLogPreview";
import DashboardPreviewRow from "./DashboardPreviewRow";

interface DashboardPreviewProps {
    title?: string;
    type: 'checkouts' | 'messages' | 'orders';
    route: string;
}

const DashboardPreview = ({ type, title, route }: DashboardPreviewProps) => {
    const { selectedDomain } = useUserContext();
    const [content, setContent] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const loadPreview = async () => {
        if(selectedDomain) {
            if(type === 'checkouts') {
                setIsLoading(true);
                const response = await getAbandonedCheckoutsPreview(selectedDomain);
                if (response.data?.report) {
                    setContent(response.data.report);
                    setIsLoading(false);
                }
            } else if(type === 'messages') {
                setIsLoading(true);
                const response = await getMessagesLogPreview(selectedDomain);
                if (response.data?.report) {
                    setContent(response.data.report);
                    setIsLoading(false);
                }

            }
        }
    }

    useEffect(() => {
        loadPreview();
    }, [selectedDomain]);

    const goToRoute = () => {
        navigate(`/${route}`);
    }

    if(isLoading) return <div className="chart-container dashboard-preview">
        {title ? <div className="chart-title">
            {title}
        </div> : null}
        <div className="preview-loader-container">
            <SkeletonTableRow opacity={4} />
            <SkeletonTableRow opacity={3} />
        </div>
        <div className="preview-footer" />
    </div>

    return (
        <div className="chart-container dashboard-preview">
            {title ? <div className="chart-title">
                {title}
            </div> : null}
            {content?.map((row: any) => <DashboardPreviewRow type={type} row={row} key={`dashboard-preview-${row.checkout_id}-${row.client_id}`} />)}
            <div className="preview-footer">
                <div onClick={goToRoute}><EyeOutlined width={10} color="#1575fb" /> <span>View All</span></div>
            </div>
        </div>
    );
}

export default DashboardPreview;